import React from 'react'

const Pagination = () => {
  return (
    <div className="w3-center w3-padding-32">
      <div className="w3-bar">
        <a className="w3-button w3-black" href="#">
          1
        </a>
        <a className="w3-button w3-hover-black" href="#">
          2
        </a>
        <a className="w3-button w3-hover-black" href="#">
          3
        </a>
        <a className="w3-button w3-hover-black" href="#">
          4
        </a>
        <a className="w3-button w3-hover-black" href="#">
          5
        </a>
        <a className="w3-button w3-hover-black" href="#">
          »
        </a>
      </div>
    </div>
  )
}

export default Pagination